import { useEffect } from "react";
import tradingService, { hasTradingHubAccess } from "./tradingService";
import { useKeycloak } from "@react-keycloak/web";

const TradingProvider = () => {
  const { keycloak, initialized } = useKeycloak();
  const messageHub = process.env.REACT_APP_TRADING_ENGINE + "hub/trade";

  useEffect(() => {
    if (!initialized || !keycloak?.token) return;

    if (!hasTradingHubAccess(keycloak)) {
      void tradingService.disconnect();
      return;
    }

    tradingService.initialize({
      keycloak,
      messageHub,
      setters: {},
    });

    void tradingService.connect();
  }, [initialized, keycloak, messageHub]);

  return null;
};

export default TradingProvider;
